module.exports = __webpack_public_path__ + "img/category-casino-hover.893e46b9.png";